import { produce } from 'immer';
import {
    FORGOT_PASSWORD_FAILURE,
    FORGOT_PASSWORD_START,
    FORGOT_PASSWORD_SUCCESS,
    LOGIN_FAILURE,
    LOGIN_START,
    LOGIN_SUCCESS,
    LOGOUT_START,
    PASSWORD_UPDATE_FAILURE,
    PASSWORD_UPDATE_START,
    PASSWORD_UPDATE_SUCCESS,
    REGISTRATION_FAILURE,
    REGISTRATION_START,
    REGISTRATION_SUCCESS,
    RESET_PASSWORD_FAILURE,
    RESET_PASSWORD_START,
    RESET_PASSWORD_SUCCESS,
} from "./authConstants.ts";

export const initialState = {
    updatePasswordPocess: null,

    registerInProcess: false,
    registerError: '',

    loggedIn: false,
    loggedInProcess: false,
    loginError: '',

    passwordForgotSent: false,
    passwordForgotError: false,

    passwordResetOk: false,
    passwordResetError: false,
};

const authReducer = (state = initialState, action) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REGISTRATION_START:
                draft.registerInProcess = true;
                draft.registerError = '';
                break;
            case REGISTRATION_SUCCESS:
                draft.registerInProcess = false;
                break;
            case REGISTRATION_FAILURE:
                draft.registerInProcess = false;
                draft.registerError = action.payload;
                break;

            case LOGIN_START:
                draft.loginError = '';
                draft.loggedInProcess = true;
                break;
            case LOGIN_SUCCESS:
                draft.loggedIn = true;
                draft.loggedInProcess = false;
                break;
            case LOGIN_FAILURE:
                draft.loginError = action.payload;
                draft.loggedInProcess = false;
                break;

            case PASSWORD_UPDATE_START:
                draft.updatePasswordPocess = '';
                break;

            case PASSWORD_UPDATE_SUCCESS:
                draft.updatePasswordPocess = null;
                break;

            case PASSWORD_UPDATE_FAILURE:
                draft.updatePasswordPocess = action.payload;
                break;

            case FORGOT_PASSWORD_START:
                draft.passwordForgotError = false;
                break;
            case FORGOT_PASSWORD_SUCCESS:
                draft.passwordForgotSent = true;
                break;
            case FORGOT_PASSWORD_FAILURE:
                draft.passwordForgotError = action.payload;
                break;

            case RESET_PASSWORD_START:
                draft.passwordResetError = false;
                break;
            case RESET_PASSWORD_SUCCESS:
                draft.passwordResetOk = true;
                break;
            case RESET_PASSWORD_FAILURE:
                draft.passwordResetError = action.payload;
                break;

            case '@@router/LOCATION_CHANGE':
                draft.passwordForgotError = false;
                draft.passwordForgotSent = false;
                draft.passwordResetError = false;
                draft.passwordResetOk = false;
                break;

            case LOGOUT_START:
                return {
                    ...initialState,
                };

            default:
                return state;
        }
    });

export default authReducer;
